import React, { useState } from "react";

const ImgCarousel = ({ carouselImg, setCarouselImg }) => {
  const [currentImg, setCurrentImg] = useState(0);

  const handleNext = () => {
    if (currentImg !== 3) {
      setCurrentImg(currentImg + 1);
    } else {
      setCurrentImg(0);
    }
  };

  const handlePrevious = () => {
    if (currentImg !== 0) {
      setCurrentImg(currentImg - 1);
    } else {
      setCurrentImg(3);
    }
  };
  return (
    <div
      className={`bg-[#3d3d3d85]   shadow-2xl fixed top-0 right-0 bottom-0 left-0 z-10`}
    >
      <div className=" my-auto">
        <span
          onClick={() => {
            setCarouselImg(null);
          }}
          className="z-20 absolute top-0 right-8 cursor-pointer text-white text-6xl rotate-45"
        >
          +
        </span>
        <span
          onClick={handlePrevious}
          className="z-20 absolute top-1/2 -translate-y-1/2 left-5 text-white bg-[#363636be] px-4 py-2 rounded-full flex justify-center items-center font-extrabold text-2xl text-center hover:bg-[#2d2d2d] cursor-pointer"
        >
          {"<"}
        </span>
        <span
          onClick={handleNext}
          className="z-20 absolute top-1/2 -translate-y-1/2 right-5 text-white bg-[#363636be] px-4 py-2 rounded-full flex justify-center items-center font-extrabold text-2xl text-center hover:bg-[#2d2d2d] cursor-pointer"
        >
          {">"}
        </span>
        <img
          src={carouselImg[currentImg]}
          alt="img"
          className="h-auto max-w-[90vw] w-[750px] rounded-md aspect-square object-cover absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2"
        />
      </div>
    </div>
  );
};

export default ImgCarousel;
